import { INetworkPrintingConfig, IGetPrinterDPIConfig, IGetPrinterDPIResult } from './NetworkPrintingTypes';
import { NetworkPrintingAdapterProvider } from './adapter/NetworkPrintingAdapterProvider';

/**
 * Main facade for network printing operations.
 * Provides a simple, unified API for network printing that delegates to the appropriate adapter
 * based on the current environment (Velocity browser or standard cross-frame).
 */
export class NetworkPrintingService {
    /**
     * Prints ZPL data to a network printer using the appropriate adapter for the current environment.
     *
     * @param config - Configuration object containing printer IP, ZPL data, and optional port
     * @returns Promise that resolves when the print operation completes successfully,
     *          or rejects with an appropriate NetworkPrintingException on failure
     */
    public static print(config: INetworkPrintingConfig): Promise<any> {
        const networkPrintingAdapter = NetworkPrintingAdapterProvider.get();
        return networkPrintingAdapter.print(config);
    }

    /**
     * Queries the DPI of a network printer.
     *
     * @param config - Configuration object containing printer IP and optional port
     * @returns Promise that resolves with the printer DPI result
     */
    public static getPrinterDPI(config: IGetPrinterDPIConfig): Promise<IGetPrinterDPIResult> {
        const networkPrintingAdapter = NetworkPrintingAdapterProvider.get();
        return networkPrintingAdapter.getPrinterDPI(config);
    }
}
